import { onMounted, onBeforeMount, ref } from 'vue';

export default function prefersReducedMotion() {
    const QUERY = window?.matchMedia(
        '(prefers-reduced-motion: no-preference)');
    const isRenderingOnServer = typeof window === 'undefined';
    const initialValue = !isRenderingOnServer && window.matchMedia(QUERY)?.matches;

    // const mediaQueryList = window.matchMedia(QUERY);
    const prefersReducedMotion = ref(initialValue);
    // const listener = event => {
    //     prefersReducedMotion.value = !event.matches;
    // }

    // onMounted(() => {
    //     mediaQueryList.addEventListener(listener);
    // });
    // onBeforeMount(() => {
    //     mediaQueryList.removeEventListener(listener);
    // });
    return prefersReducedMotion.value;
}